export default __webpack_public_path__ + "static/userflow-a807999823da48feaf3dc248a5fc3df3.jpg";